class RemoveBeneficiary {
    id;
    birthdate;
    name;
    percentage;
    isVerified;
    street;
    zip;
    suburb;
    city;
    state;
    country;
    traderId;
    createdAt;
    updatedAt;
    contactData;
    curp;
    relationship;
    identification;
    constructor(data) {
        this.id = data.id;
        this.birthdate = data.birthdate;
        this.name = data.name;
        this.percentage = data.percentage;
        this.isVerified = data.isVerified;
        this.street = data.street;
        this.zip = data.zip;
        this.suburb = data.suburb;
        this.city = data.city;
        this.state = data.state;
        this.country = data.country;
        this.traderId = data.traderId;
        this.createdAt = new Date(data.createdAt);
        this.updatedAt = new Date(data.updatedAt);
        this.contactData = data.contactData;
        this.curp = data.curp;
        this.relationship = data.relationship;
        this.identification = data.identification;
    }
}
export default RemoveBeneficiary;
